import { render } from "./InstallmentsDetailsWithProgress.vue?vue&type=template&id=5a07b112"
import script from "./InstallmentsDetailsWithProgress.vue?vue&type=script&lang=js"
export * from "./InstallmentsDetailsWithProgress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__